import { render, staticRenderFns } from "./NewsVerticalCard.html?vue&type=template&id=4fbbea26&scoped=true&"
import script from "./NewsVerticalCard.vue?vue&type=script&lang=js&"
export * from "./NewsVerticalCard.vue?vue&type=script&lang=js&"
import style0 from "./NewsVerticalCard.scss?vue&type=style&index=0&id=4fbbea26&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fbbea26",
  null
  
)

export default component.exports